import React, { PureComponent } from 'react';

import Datepicker from './datepicker';
import PromptPopout from './prompt-popout';

export default class DateElement extends PureComponent {
    static defaultProps = {
        value: {}
    }

    state = {
        visible: false
    }

    getSelectedDate(dateString) {
        if (!dateString) {
            return null;
        }

        return new Date(dateString).getTime();
    }

    handleClick = () => {
        if (!this.dateCtrl) {
            return;
        }

        if (this.state.visible) {
            this.dateCtrl.hide();

            return;
        }

        this.dateCtrl.show();
    }

    handleShow = () => {
        this.setState({
            visible: true
        });
    }

    handleHide = () => {
        this.setState({
            visible: false
        });
    }

    componentDidMount() {
        this.props.provideController && this.props.provideController({
            show: event => {
                return this.dateCtrl.show(event);
            },
            hide: () => {
                return this.dateCtrl.hide();
            }
        });
    }

    componentWillUnmount() {
        this.props.provideController && this.props.provideController(null);
    }

    setDateCtrl = ctrl => this.dateCtrl = ctrl;

    render() {
        const childrenWithProps = React.Children.map(this.props.children, child => {
            return React.cloneElement(child, {
                onClick: this.handleClick
            });
        });

        return (
            <React.Fragment>
                { childrenWithProps }

                <Datepicker
                    className="no-arrow"
                    title={this.props.title}
                    selected={this.getSelectedDate(this.props.selected)}
                    xAlign={this.props.xAlign}
                    defaultXPosition={this.props.defaultXPosition}
                    showTimeSelect={this.props.showTimeSelect}
                    onShow={this.handleShow}
                    onHide={this.handleHide}
                    showTimeSelect={this.props.showTimeSelect}
                    showQuickOptions={this.props.showQuickOptions}
                    onChange={this.props.onChange}
                    minDate={this.props.minDate}
                    onRemove={this.props.onRemove}
                    provideController={this.setDateCtrl}
                />
            </React.Fragment>
        )
    }
}
